import React from 'react';

interface UserIconProps{
  className?: string;
  color?: string;
}

const UserIcon: React.FC<UserIconProps> = ({
  className,
  color = '#9CA3AF'
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className={className} fill="none">
    <path d="M6 6C7.38071 6 8.5 4.88071 8.5 3.5C8.5 2.11929 7.38071 1 6 1C4.61929 1 3.5 2.11929 3.5 3.5C3.5 4.88071 4.61929 6 6 6Z" stroke={color} strokeLinecap="round" stroke-linejoin="round"/>
    <path d="M10.2951 11C10.2951 9.065 8.37008 7.5 6.00008 7.5C3.63008 7.5 1.70508 9.065 1.70508 11" stroke={color} strokeLinecap="round" stroke-linejoin="round"/>
  </svg>
  );
};

export default UserIcon;